export default __webpack_public_path__ + "static/media/phone-lightblue.9cf38342.svg";